import type { RecordValue } from "./types";

/** Authoring mirrors the server-derived rule; saved historical policies are displayed unchanged. */
export function votingNormalization(rules: RecordValue[]): "DIRECT_SHARE" | "WEIGHTED_MEAN" {
  return rules.length > 0 && rules.every(rule => rule.inputMethod === "DIRECT") ? "DIRECT_SHARE" : "WEIGHTED_MEAN";
}
